import { render, staticRenderFns } from "./TableNoResults.vue?vue&type=template&id=45299f6b&scoped=true&"
import script from "./TableNoResults.vue?vue&type=script&lang=ts&"
export * from "./TableNoResults.vue?vue&type=script&lang=ts&"
import style0 from "./TableNoResults.vue?vue&type=style&index=0&id=45299f6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45299f6b",
  null
  
)

export default component.exports